export default __webpack_public_path__ + "static/media/About.896bac4e.jpg";